import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import router from '../../../router/routes';
import destroyEditorData from '../../Common/destroyEditorData';

export default {
    namespaced: true,

    state: {
        deleteModal: false,
        name: '',
        order: 0,
        postData: [],
        published: false,
        sections: [],
        stepId: 0,
        route: '',
        level: 'basic'
    },

    getters: {
        postData(state) {
            return {
                name: state.name,
                order: state.order,
                published: state.published,
                level: state.level
            };
        },

        publishedText(state) {
            if (state.published) {
                return 'Published';
            } else {
                return 'Not Published';
            }
        },

        route(state) {
            if (state.stepId) {
                return '/api/step/edit/' + state.stepId;
            } else {
                return '/api/step/create';
            }
        }
    },

    mutations: {
        setStepId(state, value) {
            state.stepId = value;
        },

        setLevel(state, value) {
            state.level = value;
        },

        setSections(state, value) {
            state.sections = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setOrder(state, value) {
            state.order = value;
        },

        setPublished(state, value) {
            state.published = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setStepId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            if(state.stepId) {
                getEditorData(getters.route).then((response) => {
                    const step = response.data.data.step;
                    commit('setName', step.name);
                    commit('setOrder', step.order);
                    commit('setPublished', step.published);
                    commit('setSections', step.sections);
                    commit('setLevel', step.level);
                    commit('overlay/toggle', false, { root: true });
                });
            } else {
                commit('setName', '');
                commit('setOrder', 0);
                commit('setPublished', 0);
                commit('setSections', []);
                commit('setLevel', 'basic');
                commit('overlay/toggle', false, { root: true });
            }
        },

        saveData({ getters, commit, dispatch }) {
            saveEditorData('step', getters.route, getters.postData)
                .then((stepId) => {
                    if (router.currentRoute.name === 'StepEdit') {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                commit('overlay/toggle', false, { root: true });
                            });
                    } else {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                router.push('/step/edit/' + stepId);
                            });
                    }
                })
                .catch(() => {});
        },

        destroyData({ state, dispatch }) {
            destroyEditorData('/api/step/delete/' + state.stepId)
                .then(() => {
                    dispatch('sidebar/getSidebar', '', { root: true });
                })
                .catch(() => {});
        },
    },
};
